module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO VERTICAL X-f635826d8c249aff0e978d5d2ff00502.png";